<template>
  <div class="osBody">
    <!-- <transition name="fade"> -->
    <div class="osTree" v-show="IfShow === 0">
      <div class="TreeTop">
        票据管理组信息
      </div>
        <el-tree
        :data="osData"
        highlight-current
        accordion
        @node-click="chooseNode"
        v-loading="loading" 
        class="ElTree">
        </el-tree>
        <div class="TreeDiv" @click="TreeD">
          <img :src="ImgSrc" alt="" srcset="" style="width:100%;height:100%">
        </div>
    </div>
    <!-- </transition> -->
    <div class="osTreeOne" v-show="IfShow === 1">
       <div class="TreeDivOne" @click="TreeD">
          <img :src="ImgSrc" alt="" srcset="" style="width:100%;height:100%">
        </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "BillManTree",
  data() {
    return {
      loading: true,
      osData: [],
      AllDate:"",
      ImgSrc:require('../../assets/images/zuo@3x.png'),
      TreeNum:1,
      IfShow:0,
    }
  },
  methods: {
    chooseNode(data) {
    this.$emit('NodeData',data)
    },
    TreeD(){
      if(this.IfShow >= 1 ) {
        this.IfShow = 0
        this.ImgSrc=require('../../assets/images/zuo@3x.png')
      } else{
        this.IfShow ++
        this.ImgSrc=require('../../assets/images/shouhui@3x.png')
      }
    },
    getUserOffice() {
      this.$http.get(this.$requestUrl.GET_BILL_MAMLIST).then((res) => {
        let data = res.data;
        let arr =[]
        if (200 === data.code) {
            for(let val of data.data){
                 var parent = {//转换成el-Cascader可以识别的数据结构
                    'label':val.groupNum+"|"+val.groupName,
                    'Pid': val.groupNum,
                    'type':val.remarks,
                    'value':val.id,
                }
                arr.push(parent)
            }
              this.$emit('AllData',arr)
             this.osData = arr
             this.loading=false
        } else {
          this.$message.error(data.msg)
          this.loading=false
        }
      }).catch(() => {
        this.$message.error(this.$errorMessage.SEVER_ERROR)
        this.loading=false
      })
    },


  },
  mounted() {
    this.getUserOffice();
  }
}
</script>

<style scoped lang="scss">
.osBody {
  // width: 200px;
  height: 700px;
  float: left;
  margin-right:1% ;
  margin-top: -14px;
  .osTree{
    width: 220px;
    height: 700px;
    position: relative;
  }
  .osTreeOne{
    width: 20px;
    height: 700px;
    position: relative;
  }
}
.TreeDiv{
  width: 20px;
  height: 60px;
  border-radius: 10px;
  z-index: 500;
  position: absolute;
  top: 45%;
  right: -17px;
}
.TreeDivOne{
    width: 25px;
  height: 70px;
  border-radius: 10px;
  z-index: 500;
  position: absolute;
  top: 45%;
  left:-3px;
}

.ElTree{
  z-index: 500;
  height: 700px;
}
.TreeTop{
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #fff;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Chrome/Safari/Opera */
  -khtml-user-select: none; /* Konqueror */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; 
}
</style>